@if (tabular(); as tab) {
<p-table
  #table
  [loading]="loading()"
  dataKey="id"
  [columns]="tab.columns"
  [virtualScroll]="true"
  [styleClass]="tab.className"
  [responsive]="true"
  [rows]="10"
  [value]="$any(tab.data | async)"
  [resizableColumns]="true"
  columnResizeMode="expand"
  [scrollable]="true"
  [virtualScrollOptions]="{
    numToleratedItems: 30,
    delay: 10,
    scrollHeight: '500px'
  }"
  scrollHeight="500px">
  <ng-template pTemplate="emptymessage">
    <p class="p-4 m-auto text-slate-500">No results found.</p>
  </ng-template>

  <ng-template pTemplate="summary">
    <div class="flex text-slate-500 gap-2 justify-end text-xs items-center">
      <span class="mr-2 font-medium">Colors settings:</span>
      <p-colorPicker
        title="Highlight color"
        appendTo="body"
        [(ngModel)]="tab.colorGenerator.accentColor"></p-colorPicker>
      <p-colorPicker
        title="Minimum value color"
        appendTo="body"
        [(ngModel)]="tab.colorGenerator.minColor"></p-colorPicker>

      <p-slider
        title="Balance stepper"
        class="w-[6rem] mx-2"
        [(ngModel)]="tab.colorGenerator.factor"
        [min]="0"
        [max]="1"
        [step]="0.1"></p-slider>

      <p-colorPicker
        title="Maximum value color"
        appendTo="body"
        [(ngModel)]="tab.colorGenerator.maxColor"></p-colorPicker>

      <div class="border-l border-slate-300 mx-2 pl-4 flex items-center">
        <span class="mr-2 font-medium">Sync scrolling:</span>
        <p-checkbox [(ngModel)]="syncScrolling" [binary]="true" inputId="syncScrolling"></p-checkbox>
      </div>

      <div class="flex items-center">
        <span class="ml-2 mr-2 font-medium">Font size:</span>
        <p-slider
          title="Font Size stepper"
          class="w-[6rem]"
          [(ngModel)]="tab.fontSize"
          [min]="0"
          [max]="3"
          [step]="1"></p-slider>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="colgroup" let-columns>
    <colgroup>
      @for (col of columns; track col.field) {
      <col />
      }
    </colgroup>
  </ng-template>

  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (col of columns; track col.field) {
      <th
        [pSortableColumn]="col.field"
        pResizableColumn
        [title]="col.field"
        class="header-style text-sm"
        [ngClass]="{ 'bg-slate-200': col.index === tab.xy[1] }">
        {{ col.header | truncate : 10 }}
        <p-sortIcon class="text-xs" [field]="col.field"></p-sortIcon>
      </th>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
    <tr>
      @for (col of columns; track col.field; let i = $index) { @switch (col.type) { @case ('date') { @if (tab.xy$ |
      async; as xy) {
      <td class="cell-style" [ngClass]="{ 'bg-slate-200': rowData['id'] === xy[0] }">
        <span class="text-sm text-slate-400 mr-2">{{ rowIndex + 1 | numberFormatter }}</span>
        <span class="font-semibold text-sm text-slate-600 bg-slate-100 py-1 px-2 rounded-md">
          {{ rowData[col.field] | date : dateFormat() }}
        </span>
      </td>
      } } @default {
      <td class="cell-style" [ngStyle]="tab.getStyleColors(rowData[col.field], rowData['id'], i - 1)">
        {{ rowData[col.field] }}
      </td>
      } } }
    </tr>
  </ng-template>

  <ng-template pTemplate="loadingbody" let-columns="columns">
    <tr>
      @for (col of columns; track col.field; let even = $even) {
      <td>
        <p-skeleton [ngStyle]="{ width: even ? (col.field === 'timestamp' ? '30%' : '40%') : '60%' }"></p-skeleton>
      </td>
      }
    </tr>
  </ng-template>
</p-table>
}
